/* import __COLOCATED_TEMPLATE__ from './loading-button.hbs'; */
/* RESPONSIBLE TEAM: team-purchase */
import Component from '@glimmer/component';
import { tracked } from 'tracked-built-ins';
import { taskFor } from 'ember-concurrency-ts';
import { action } from '@ember/object';
import ENV from 'embercom/config/environment';
import { type TaskGenerator } from 'ember-concurrency';

export interface Args {
  disabled?: boolean;
  onClickTask: () => TaskGenerator<void>;
  label: string;
  displayStrings: string[];
  showOverlay?: boolean;
  isProcessing: boolean;
  startCyclingText?: boolean;
}

interface Signature {
  Args: Args;
  Blocks: any;
  Element: HTMLElement;
}

export default class LoadingButton extends Component<Signature> {
  @tracked interval: NodeJS.Timeout | null = null;
  @tracked processingLabelIndex = 0;

  @action
  maybeStopTimer() {
    if (!this.args.isProcessing) {
      this.clearTimer();
    }
  }

  @action
  maybeStartTimer() {
    if (this.args?.startCyclingText && this.args.isProcessing && !this.interval) {
      this.startTimer();
    }
  }

  @action
  startProcessing() {
    taskFor(this.args.onClickTask).perform();
    if (this.args.startCyclingText === undefined) {
      this.startTimer();
    }
  }

  startTimer() {
    this.processingLabelIndex = 0;
    this.interval = setInterval(() => {
      if (this.processingLabelIndex >= this.args.displayStrings.length - 1) {
        this.clearTimer();
      } else {
        this.processingLabelIndex++;
      }
    }, ENV.APP.loadingButtonContentDelay);
  }

  get processingLabel() {
    return this.args.displayStrings[this.processingLabelIndex];
  }

  get showProcessingLabels() {
    return this.args.startCyclingText && this.args.isProcessing;
  }

  clearTimer() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  willDestroy() {
    super.willDestroy();
    this.clearTimer();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'LoadingButton::LoadingButton': typeof LoadingButton;
    'loading-button/loading-button': typeof LoadingButton;
  }
}
